import { create } from 'zustand';
import { cabinet } from '../api/cabinet';
import type { PublicSite } from '../api/types';
import { FALLBACK_MAX_UPLOAD_BYTES } from '../features/upload/uploadFlow';
import { useI18n } from '../i18n';

interface SiteState {
  site: PublicSite | null;
  loaded: boolean;
  /** Ліміт розміру документа з GET /public/site; поки сайт не завантажився (чи старий API) — 20 МБ. */
  maxUploadBytes: number;
  load: () => Promise<void>;
}

/** max_upload_bytes з /public/site або 20 МБ, якщо поля немає. */
export function maxUploadBytes(site: PublicSite | null | undefined): number {
  const v = site?.max_upload_bytes;
  return typeof v === 'number' && v > 0 ? v : FALLBACK_MAX_UPLOAD_BYTES;
}

/** GET /public/site gives the default language and the company phone/email for this country site. */
export const useSite = create<SiteState>((set, get) => ({
  site: null,
  loaded: false,
  maxUploadBytes: FALLBACK_MAX_UPLOAD_BYTES,
  async load() {
    if (get().loaded) return;
    try {
      const site = await cabinet.site();
      set({ site, loaded: true, maxUploadBytes: maxUploadBytes(site) });
      useI18n.getState().setSiteLocale(site?.default_locale);
    } catch {
      set({ loaded: true });
    }
  },
}));
